import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { PurchasePassFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPurchasePassPOSTErrorResponse, ParkPurchasePassPOSTRequest, ParkPurchasePassPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchPurchasePass = async (data: ParkPurchasePassPOSTRequest): Promise<ParkPurchasePassPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPurchasePassPOSTSuccessResponse>("/purchase-pass", data);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPurchasePassPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PurchasePassFailReason };
  }
};
